module.exports = __webpack_public_path__ + "img/logoreunivest.1a92cfa4.png";